import { render, staticRenderFns } from "./BoardEmptySearchLayout.vue?vue&type=template&id=481c78ad&scoped=true&"
import script from "./BoardEmptySearchLayout.vue?vue&type=script&lang=js&"
export * from "./BoardEmptySearchLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "481c78ad",
  null
  
)

export default component.exports